export const BOOK_APPOINTMENT_ENDPOINT = '/booking-portal/Appointment/BookAppointment';
